import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PasswordResetForm from '../components/auth/PasswordResetForm';

const PasswordReset = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#f8f5f0'
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <div className="text-center mb-4">
              <img
                src="/Logos/logo-sin-fondo.png"
                alt="Lumière Tica"
                style={{ maxWidth: '200px', marginBottom: '20px' }}
              />
              <h2 style={{ color: '#2A2F35', fontWeight: 'bold' }}>
                Restablecer Contraseña
              </h2>
              <p style={{ color: '#555' }}>
                Recupera el acceso a tu cuenta
              </p>
            </div>

            <Card className="shadow-lg border-0">
              <Card.Body className="p-4">
                <PasswordResetForm />
                
                <div className="text-center mt-3">
                  <p style={{ color: '#555', marginBottom: '0' }}>
                    ¿Recordaste tu contraseña?{' '}
                    <Link 
                      to="/admin/login" 
                      style={{ 
                        color: '#D4AF37', 
                        textDecoration: 'none',
                        fontWeight: '500'
                      }}
                    >
                      Inicia Sesión
                    </Link>
                  </p>
                </div>
              </Card.Body>
            </Card>

            <div className="text-center mt-3">
              <small style={{ color: '#555' }}>
                © 2026 Lumière Tica. Todos los derechos reservados.
              </small>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PasswordReset;
